// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__-QlJk","is-active":"Sidebar_is-active__wlIJ2"};